export default {
  footerText: "Copyright © 2020 AINTOP, Inc. - All rights reserved.",
};
